<template>
    <v-overflow-btn
        solo
        dense
        :editable="admin"
        clearable
        v-model="clinic"
        :items="clinics"
        :label="$t('components.ClinicSelector.PlaceholderLabel')"
        item-value="text"
        :loading="loading"
        hide-details
        :class="`elevation-${elevation}`"
        @click:clear.prevent="clear"
        v-if="admin || clinics.length > 1"
        @update:search-input="typing"/>
</template>

<script>
import AuthAPI from '@/utils/AuthAPI';
import DataAPI from '@/utils/DataAPI';
import EventBus from '@/utils/EventBus';

/**
 * ClinicSelector allows to the customers that have more than one clinic to 
 * select the data between clinics. If the current user is an administrator, it
 * allows to select over all customers clinics. It uses the AuthAPI class to
 * the admin verification and the DataAPI class to get the data from the 
 * database.
 */
export default {
    name: 'ClinicSelector',
    props: {
        elevation: {
            type: Number,
            default: 1
        },
        default: {
            type: String,
            default: ""
        }
    },
    data: () => ({
        clinic: false,
        clinics: [],
        loading: true,
        admin: false
    }),
    async mounted() {
        await this.init();
    },
    methods: {
        async init() {
            this.loading = true;
            const [ success, user ] = await AuthAPI.currentUser();

            this.admin = user.isAdmin;

            if (!success) EventBus.$emit('popup', 'Error getting clinics');
            else if (user.isAdmin) {
                try {
                    const clinics = await DataAPI.getClinics();
                    this.clinics = clinics.filter(clinic => clinic.replace(/\s/g, '').length > 0);
                } catch (e) {
                    console.info(e);
                    EventBus.$emit('popup', 'Error getting clinics');
                }
            } else this.clinics = user.attributes.clinics;
            this.loading = false;
        },
        async typing(value) {
            if (this.admin) {
                try {
                    if (value === undefined) this.clear();
                    else if (value !== null && value !== this.default) {
                        this.loading = true;
                        const query = value.length > 2 ? value : false;
                        const clinics =  await DataAPI.getClinics(query);
                        this.clinics = clinics.filter(clinic => clinic.replace(/\s/g, '').length > 0);
                        this.loading = false;
                    } 
                } catch (e) {
                    console.info(e);
                    EventBus.$emit('Error getting clinics');
                }
            }
        },
        async clear() {
            this.clinic = false;
            this.clinics = [];
            await this.init();
        }
    },
    watch: {
        default(value) {
            this.clinic = value;
            if (!this.clinics.includes(value)) this.clinics.push(value);
        },
        clinic(value) {
            if (value !== this.default) this.$emit("selected", value);
        }
    }
}
</script>